module.exports = __webpack_public_path__ + "static/media/87gal20.e1fb6a46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/87gal/87gal20.jpg
// module id = 192
// module chunks = 0